// Vendor libraries
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfigModule } from 'Angular/config/config.module';
// Module imports
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

// Components
import { BackgroundJobsProgressPopoverComponent } from 'NotificationsApp/ts/features/background-jobs-progress-popover/components/background-jobs-progress-popover/background-jobs-progress-popover.component';
import { BackgroundJobsProgressPopoverItemComponent } from 'NotificationsApp/ts/features/background-jobs-progress-popover/components/background-jobs-progress-popover-item/background-jobs-progress-popover-item.component';

@NgModule({
    declarations: [BackgroundJobsProgressPopoverComponent, BackgroundJobsProgressPopoverItemComponent],
    imports: [CommonModule, ConfigModule, IconModule, TooltipModule],
    exports: [BackgroundJobsProgressPopoverComponent],
})
export class BackgroundJobsProgressPopoverModule {}
